// extracted by mini-css-extract-plugin
export default {"rentalView":"rental_rentalView__bL6uK","rentalTable":"rental_rentalTable__Gne97"};